export default {"src":"/_next/static/media/up_filled.9dbc1985.svg","height":24,"width":24};